(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_user_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_axessimpact_user_domain'.");
    }
    root.kotlin_org_axessimpact_user_domain = factory(typeof kotlin_org_axessimpact_user_domain === 'undefined' ? {} : kotlin_org_axessimpact_user_domain, kotlin_kotlin);
  }
}(this, function (_, kotlin_kotlin) {
  //region block: imports
  var listOf = kotlin_kotlin.$crossModule$.listOf;
  //endregion
  'use strict';
  //region block: pre-declaration
  //endregion
  function RoleValues() {
    Roles_instance = this;
    this.ADMIN_1 = 'admin';
    this.ASSET_MANAGER_1 = 'asset_manager';
    this.STAKE_HOLDER_1 = 'stake_holder';
    this.list_1 = listOf(['admin', 'asset_manager', 'stake_holder']);
  }
  RoleValues.prototype._get_ADMIN__2138328706_zd3szm_k$ = function () {
    return this.ADMIN_1;
  };
  RoleValues.prototype._get_ASSET_MANAGER__3503615859_d35eod_k$ = function () {
    return this.ASSET_MANAGER_1;
  };
  RoleValues.prototype._get_STAKE_HOLDER__431578426_74y81m_k$ = function () {
    return this.STAKE_HOLDER_1;
  };
  RoleValues.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this.list_1;
  };
  RoleValues.$metadata$ = {
    simpleName: 'Roles',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(RoleValues.prototype, 'ADMIN', {
    configurable: true,
    get: RoleValues.prototype._get_ADMIN__2138328706_zd3szm_k$
  });
  Object.defineProperty(RoleValues.prototype, 'ASSET_MANAGER', {
    configurable: true,
    get: RoleValues.prototype._get_ASSET_MANAGER__3503615859_d35eod_k$
  });
  Object.defineProperty(RoleValues.prototype, 'STAKE_HOLDER', {
    configurable: true,
    get: RoleValues.prototype._get_STAKE_HOLDER__431578426_74y81m_k$
  });
  Object.defineProperty(RoleValues.prototype, 'list', {
    configurable: true,
    get: RoleValues.prototype._get_list__802566509_d9tsa5_k$
  });
  var Roles_instance;
  function Roles_getInstance() {
    if (Roles_instance == null)
      new RoleValues();
    return Roles_instance;
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$user = $org$axess$s2.user || ($org$axess$s2.user = {});
    var $org$axess$s2$user$domain = $org$axess$s2$user.domain || ($org$axess$s2$user.domain = {});
    var $org$axess$s2$user$domain$model = $org$axess$s2$user$domain.model || ($org$axess$s2$user$domain.model = {});
    Object.defineProperty($org$axess$s2$user$domain$model, 'RoleValues', {
      configurable: true,
      get: Roles_getInstance
    });
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_user_domain.js.map